// Standard library imports
import React, { useState } from 'react';
// External library imports

// Internal module imports
import TabsComponent from '../../../../components/Tabs/Tabs';
import { NumberParam } from 'use-query-params';
import { useQueryParamWithDefault } from '../../../../hooks';
import { MonitoringAlerts } from './MonitoringAlerts';
import ControlPanel from './ControlPanel';
// import EmailSubcription from './EmailSubcription';

const GlobalControl = ({ cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('tab', NumberParam, 0, cId);

    const tabs = [
        {
            name: 'Notification Control Panel',
            component: <MonitoringAlerts />,
            tabId: 1,
        },
        {
            name: 'Control Panel',
            component: <ControlPanel />,
            tabId: 2,
        },
        // {
        //     name: 'Email Subscription',
        //     component: <EmailSubcription />,
        //     tabId: 3,
        // },
    ];

    return (
        <div className={'ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default GlobalControl;
